module.exports = __webpack_public_path__ + "static/media/Colby-Natal-Headshot.e0541b61.jpeg";